import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Subscription from "./components/Subscription";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Only Subscription page is accessible */}
        <Route path="/" element={<Subscription />} />
        <Route path="/subscription" element={<Subscription />} />

        {/* Block/redirect every other URL */}
        <Route path="*" element={<Navigate to="/subscription" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;